import { render } from "./AcknowledgedPass.vue?vue&type=template&id=8c8ed61c"
import script from "./AcknowledgedPass.vue?vue&type=script&lang=js"
export * from "./AcknowledgedPass.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__